<!--
 * @Description: 用户持有银行卡信息操作组件，签约/解约 由index.js 配置引入
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-24 14:46:45
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="acctManager" :back-url-query="{ activeIndex: '4-1' }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager?activeIndex=4-1' }">
                    银行卡
                </el-breadcrumb-item>
                <el-breadcrumb-item>银行卡签约/解约</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>

        <div class="bizcomp-sign-and-unsign">
            <div class="header-title">银行卡签约/解约</div>
            <el-table :data="bankInfo" class="tab-list-tit table-list">
                <el-table-column
                    prop="bankcode"
                    label="银行卡名称"
                    align="center"
                    :formatter="formatterName"
                />
                <el-table-column
                    prop="depositcard"
                    label="银行卡号码"
                    align="center"
                ></el-table-column>
                <el-table-column
                    prop="signstatus"
                    label="签约状态"
                    align="center"
                    :formatter="formatterSignstatus"
                ></el-table-column>
                <el-table-column prop="signstatus" label="操作" align="center">
                    <template slot-scope="scope">
                        <span class="sign-operate" v-on:click="signOperate(scope.row)">
                            {{ scope.row.signstatus == "0" ? "签约" : "解约" }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog
                title="银行卡签约"
                :visible.sync="dialogShow"
                class="prop info-tips"
                width="580px"
            >
                <div class="dialog-contain">
                    <div class="bank-contain">
                        <div class="bank-title">
                            银行全称：
                            <span class="bank-text">
                                {{ $cache.getDict("110080", selectBankInfo.bankcode) }}
                            </span>
                        </div>
                        <div class="bank-title">
                            银行卡号：
                            <span class="bank-text">{{ selectBankInfo.depositcard }}</span>
                        </div>
                        <div class="bank-title">
                            证件类型：
                            <span class="bank-text">
                                {{ $cache.getDict("130007", $cache.getUser().certificatetype) }}
                            </span>
                        </div>
                        <div class="bank-title">
                            银行卡证件号码：
                            <span class="bank-text">{{ $cache.getUser().certificateno }}</span>
                        </div>
                        <div v-if="isPwdCheck" class="bank-title password-contain">
                            交易密码：
                            <el-input
                                v-model.trim="pwd"
                                type="password"
                                class="password-input"
                                placeholder="请输入交易密码"
                                :maxlength="16"
                            />
                            <!--                            <span
                                class="redemp-btn margin-l-10"
                                v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                            >
                                <span class="like-a">忘记密码？</span>
                            </span>-->
                        </div>
                    </div>
                    <div class="checkbox-contain">
                        <el-checkbox v-model="checked" class="check-style"></el-checkbox>
                        <span class="agree-text">我已阅读并同意</span>
                        <span class="agree-content">《电子交易委托转账收付款服务协议(托收)》</span>
                    </div>
                    <div class="btn-contain">
                        <button class="cancel-btn" v-on:click="dialogShow = false">取消</button>
                        <button
                            :disabled="!checked"
                            :class="
                                'confirm-btn ' +
                                (!checked || (isPwdCheck && !pwd)
                                    ? 'confirm-btn-disabled'
                                    : 'confirm-btn-active')
                            "
                            v-on:click="sendBankConfirm"
                        >
                            确定
                        </button>
                    </div>
                </div>
            </el-dialog>
        </div>
        <footer-questions
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
import footerQuestions from "@/components/layout/footerQuestions.vue";

export default {
    name: "AddBank",
    components: { footerQuestions },
    mixins: [mixin],
    data() {
        return {
            isPwdCheck: false,
            dialogShow: false,
            checked: false,
            bankInfo: [],
            selectBankInfo: {},
            pwd: "",
            commonQuestion: [
                {
                    title: "1、为什么要签约？ ",
                    answer: "",
                    showFlag: false
                },
                {
                    title: "2、如果解约会有什么影响？",
                    answer: "",
                    showFlag: false
                }
            ],
            warningHtml:
                "<p>1、签约代扣协议后，您可轻松进行基金定投,并可更快速完成基金购买流程； </p><p>2、您绑定的农行卡可以直接在此板块完成签约或解约，其它银行包括：工行、建行、招行、平安、民生、浦发为默认开通，不能解约。</p>"
        };
    },
    watch: {
        dialogShow(val) {
            if (!val) {
                this.checked = false;
                this.pwd = "";
            }
        }
    },
    created() {
        this.getBankInfo();
    },
    methods: {
        async getBankInfo() {
            const reqRes = await userApi.getMyBankCards();
            const res = reqRes.data;
            if (res.data) {
                this.bankInfo = res.data ? res.data : [];
                this.bankInfo = this.bankInfo.filter((item) => {
                    return (
                        item.paycenterid !== "0001" &&
                        item.paycenterid !== "1000" &&
                        item.authenticateflag == "1"
                    );
                });
            }
        },
        formatterName(row, column, value) {
            return (
                this.$cache.getDict("110080", row.bankcode) + "(" + row.depositcard.slice(-4) + ")"
            );
        },
        formatterSignstatus(row, column, value) {
            return row.signstatus == "0" ? "未签约" : "已签约";
        },
        signOperate(bankInfo) {
            let bankCate = "";
            if (bankInfo.signstatus == "0") {
                bankCate = "0A3";
            } else {
                bankCate = "0B6";
            }
            this.$util.queryValidPwdTrdMethod(bankCate, (res) => {
                this.isPwdCheck = res;
                this.dialogShow = true;
                this.selectBankInfo = bankInfo;
            });
        },
        sendBankConfirm() {
            this.dialogShow = false;
            if (this.selectBankInfo.signstatus == "0") {
                // 签约
                this.getParams();
            } else {
                // 解约 目前调用删卡接口
                this.delBankFn();
            }
        },
        async delBankFn() {
            let _pwd = "";
            if (this.isPwdCheck) {
                _pwd = this.$util.enc(this.pwd);
            }
            const res = await userApi.delCardPayChannel({
                bankcardid: this.selectBankInfo.bankcardid,
                paychannel: this.selectBankInfo.paycenterid,
                tradepassword: _pwd
            });
            if (res.code === "0") {
                this.getBankInfo();
                this.$message({
                    type: "success",
                    message: "银行卡解约成功!"
                });
            }
        },
        async getParams() {
            let params = {};
            params.biztype = "02";
            params.custname = this.$cache.getUser().custname;
            params.certificateno = this.$cache.getUser().certificateno;
            params.certificatetype = this.$cache.getUser().certificatetype;
            params.mobileno = this.selectBankInfo.mobileno;
            params.bankcardid = this.selectBankInfo.bankcardid;
            params.channelid = this.bankInfo.paycenterid + this.bankInfo.bankcode;
            params.depositname = this.$cache.getUser().custname;
            params.channelname =
                this.$cache.getDict("110079", this.bankInfo.paycenterid).toString().substr(0, 4) +
                "-" +
                this.$cache.getDict("110080", this.bankInfo.bankcode);
            this.randomToken = this.generateRandomNumber();
            params.pagecallbackurl =
                window.location.origin + "" + this.$util.getConfig().api.v5BaseUrl != "/"
                    ? this.$util.getConfig().api.v5BaseUrl
                    : "" + "/bank/redirect?token=" + this.randomToken;
            this.sendBank(params);
        },
        async sendBank(data) {
            const res = await userApi.sendBindCardSms(data);
            if (res.data) {
                const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                if (pageParam) {
                    pageParam = JSON.parse(pageParam);
                }
                const bankgateserialno = res.data.bankgateserialno;
                this.$util.openPostWindow(pageUrl, pageParam, "_blank");
                const params = {
                    token: this.randomToken,
                    certificatetype: this.$cache.getUser().certificatetype,
                    certificateno: this.$cache.getUser().certificateno,
                    bankcode: this.selectBankInfo.bankcode,
                    depositcard: this.selectBankInfo.bankcard,
                    depositname: this.$cache.getUser().custname,
                    mobileno: this.selectBankInfo.newMobile,
                    paychannel: this.selectBankInfo.paycenterid,
                    bankgateserialno: bankgateserialno,
                    signtype: "0"
                };
                if (this.selectBankInfo.bankcardid) {
                    params.bankcardid = this.selectBankInfo.bankcardid;
                }
                this.$util.confirmBankAuth(this, params, "BankPageAuthentication", () => {
                    // 签约解约要做的操作
                });
            }
        },
        generateRandomNumber() {
            let randomNum = "";
            while (randomNum.length < 16) {
                randomNum += Math.floor(Math.random() * 10).toString();
            }
            return randomNum;
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-sign-and-unsign {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-bottom: 40px;
    margin-bottom: 20px;
    .header-title {
        width: 1160px;
        padding: 17px 0 21px 0;
        margin-left: 20px;
        border-bottom: 1px solid #f1f1f1;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
    }
    .table-list {
        width: 1160px;
        margin: auto;
        margin-top: 20px;
        border-left: 1px solid #f1f1f1;
        border-right: 1px solid #f1f1f1;
        .sign-operate {
            color: #e60012;
            cursor: pointer;
        }
    }

    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
        }
    }
    .dialog-contain {
        padding: 28px 20px;
        .bank-contain {
            font-size: 18px;
            font-weight: normal;
            line-height: 40px;
            .bank-title {
                color: #666666;
            }
            .bank-text {
                color: #333333;
            }
            .password-contain {
                display: flex;
            }
            .password-input {
                width: 300px;
                margin-right: 5px;
            }
        }
        .checkbox-contain {
            margin: 30px 0 0 52px;
            font-size: 14px;
            font-weight: normal;
            line-height: 22px;
            .agree-text {
                margin-left: 4px;
                color: #999999;
            }
            .agree-content {
                color: #e60012;
                cursor: pointer;
            }
        }
        .btn-contain {
            margin-top: 40px;
            .cancel-btn {
                margin-left: 50px;
                width: 180px;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                background: #e4e4e4;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                color: #666666;
                cursor: pointer;
                border: none;
            }
            .confirm-btn {
                margin-left: 40px;
                width: 180px;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                border: none;
                color: #ffffff;
            }
            .confirm-btn-active {
                background: #e60012;
                cursor: pointer;
            }
            .confirm-btn-disabled {
                background: #f7b2b8;
            }
        }
    }
}
</style>
